import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";

import classNames from "classnames";

import { DeleteModalParams } from "../types/advertisers";

import { SPONSOR_LOGO_URL } from "../../../../lib/globals";

const DeleteModal = ({
    show,
    setShow,
    handleDelete,
    sponsor,
}: DeleteModalParams): React.JSX.Element => {
    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}
            centered={true}
            className={classNames("deleteAdvertiserModal")}
        >
            <Modal.Header>
                <Modal.Title>Delete Advertiser?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col lg={5}>
                        {sponsor?.logo && (
                            <img
                                src={`${SPONSOR_LOGO_URL}${sponsor?.logo}`}
                                alt={`${sponsor?.name} logo`}
                                className="sponsorLogo img-fluid"
                            />
                        )}
                    </Col>
                    <Col lg={7}>
                        <b>Name:</b> {sponsor?.name}
                        <br />
                        <b>Link:</b> {sponsor?.link}
                        <br />
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => setShow(false)}>
                    No
                </Button>
                <Button
                    variant="danger"
                    onClick={() => {
                        handleDelete(sponsor?.id);
                        setShow(false);
                    }}
                >
                    Yes
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteModal;
